// Shared helpers for the public machine-readable entity endpoints under /data.
//
// Every feed is generated from the same source of truth the rendered pages
// use, so a feed can never silently contradict the site. Feeds are data
// documents, not indexable pages: they are served noindex/follow.

import { entityLastModified } from "@/lib/entity";

/** Bumped only when the shape of a feed document changes. */
export const DATA_FEED_VERSION = "1.0.0";

export const DATA_FEEDS: Array<{ id: string; path: string; label: string; description: string }> = [
  {
    id: "buddha-ka",
    path: "/data/buddha-ka.json",
    label: "Buddha KA entity record",
    description: "Canonical artist identity: names, roles, origin, official profiles, and canonical @id.",
  },
  {
    id: "kafrequency",
    path: "/data/kafrequency.json",
    label: "KAfrequency entity record",
    description: "The ecosystem/organization Buddha KA founded, as a distinct entity from the person.",
  },
  {
    id: "discography",
    path: "/data/discography.json",
    label: "Discography",
    description: "Every release with slug, type, release date, state, and canonical URL.",
  },
  {
    id: "books",
    path: "/data/books.json",
    label: "Books",
    description: "Published books with author, category, and canonical URL.",
  },
  {
    id: "concepts",
    path: "/data/concepts.json",
    label: "Concept layer",
    description: "The canonical KAfrequency concept vocabulary with definitions and canonical URLs.",
  },
  {
    id: "entity-registry",
    path: "/data/entity-registry.json",
    label: "Governed entity registry",
    description: "Every canonical identity fact with its verification state, provenance note, and genuine change date.",
  },
  {
    id: "press",
    path: "/data/press.json",
    label: "Press record",
    description: "Approved bios, fact sheet, press contact, and machine-readable press resources.",
  },
];

/** Standard JSON response for a public data feed. */
export function dataFeed(body: Record<string, unknown>, lastUpdated?: string): Response {
  const payload = {
    version: DATA_FEED_VERSION,
    // Genuine change date from persisted data — never deployment time.
    lastUpdated: lastUpdated ?? entityLastModified(),
    ...body,
  };
  return new Response(JSON.stringify(payload, null, 2), {
    headers: {
      "content-type": "application/json; charset=utf-8",
      "cache-control": "public, max-age=600, s-maxage=3600",
      "access-control-allow-origin": "*",
      "x-robots-tag": "noindex, follow",
    },
  });
}
